// 🔹 IMPORTANT: You must run `npm install xlsx-js-style` for the bold headers to work.
import * as XLSX from "xlsx-js-style";

const ExcelExport = ({
  data,
  columns,
  fileName = "report.xlsx",
  reportTitle = "Report",
  reportFilters = {},
  companyName = "Krishok Bandhu Agro Limited", // Updated default
  groupKeyFields = [],
  hiddenRepeatKeys = [],
}) => {

  const generateExcel = () => {
    if (!data || data.length === 0) {
      alert("No data available to export.");
      return;
    }

    // 🔹 Improved replacement logic to catch partial matches inside headers
    const processHeaderName = (name) => {
      if (!name) return "";
      let n = String(name);
      n = n.replace(/Customer/gi, "Party");
      n = n.replace(/Total Alt Qty/gi, "Total Alternative Quantity");
      n = n.replace(/Alt Qty/gi, "Alternative Quantity");
      n = n.replace(/Total Qty/gi, "Total Quantity");
      n = n.replace(/\bQty\b/gi, "Quantity");
      n = n.replace(/Alt UOM/gi, "Kg/Lit/Pcs");
      n = n.replace(/\bUOM\b/gi, "Ctn/Bag/Pcs");
      return n;
    };


    const headerRows = [
      [companyName],
      [reportTitle],
      [],
    ];

    Object.entries(reportFilters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "" && value !== "All") {
        const label = processHeaderName(key)
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, str => str.toUpperCase());
        headerRows.push([label, value]);
      }
    });
    headerRows.push([]);

    // 2. Table Headers
    const tableHeader = ["S.No", ...columns.map(col => processHeaderName(col.header || col.label || col.title || col.key))];

    // 3. Table Data
    // 3. Table Data
    const visibleRowMap = {};
    if (groupKeyFields.length > 0) {
      const seen = new Set();
      data.forEach((row, index) => {
        const rowKey = groupKeyFields.map(field => row[field]).join("__");
        visibleRowMap[index] = !seen.has(rowKey);
        seen.add(rowKey);
      });
    } else {
      data.forEach((_, index) => { visibleRowMap[index] = true; });
    }

    const tableData = data.map((row, rowIndex) => {
      const rowData = columns.map(col => {
        const key = col.key;
        if (hiddenRepeatKeys.includes(key) && !visibleRowMap[rowIndex]) return "";
        const value = row[key];

        if (value === null || value === undefined || value === "") return "-";

        // 🆕 Force numeric columns to real JS numbers so SheetJS stores
        // them as numeric cells (t: "n"), which is required for the
        // "#,##0.00" number format below to actually apply. Without this,
        // string values like "0.000" from the API get written as plain
        // text and display with whatever decimal count the backend sent.
        if (col.isNumeric) {
          const num = Number(value);
          return isNaN(num) ? "-" : num;
        }

        return value;
      });
      return [rowIndex + 1, ...rowData];
    });

    // 4. Total Row
    // 🆕 Build the total row by mapping over `columns` exactly once — same
    // shape as the header row (["S.No", ...columns]) — so nothing gets
    // double-counted. The first real column (index 0, e.g. "SL") gets the
    // "TOTAL" label instead of being seeded separately beforehand.
    const totalRow = ["", ...columns.map((col, idx) => {
      if (idx === 0) return "TOTAL";
      if (!col.isNumeric) return "";

      const key = col.key;
      const numericValues = data.map((row, rIdx) =>
        (hiddenRepeatKeys.includes(key) && !visibleRowMap[rIdx]) ? null : row[key]
      ).filter(val => val !== null && val !== "" && !isNaN(Number(val)));

      return numericValues.length > 0
        ? numericValues.reduce((s, v) => s + Number(v), 0)
        : "";
    })];

    const sheetData = [...headerRows, tableHeader, ...tableData, totalRow];
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // 5. Formatting (Bold & Decimals)
    // 5. Formatting (Bold & Decimals)
    const range = XLSX.utils.decode_range(worksheet['!ref']);
    const tableHeaderRowIndex = headerRows.length; // Exact index of the header row

    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (!worksheet[cellAddress]) continue;

        // 🆕 Bold the Company Name row (row 0) and Report Title row (row 1)
        if (R === 0 || R === 1) {
          worksheet[cellAddress].s = { font: { bold: true } };
        }

        // 🔹 Bold the Table Header Row
        if (R === tableHeaderRowIndex) {
          worksheet[cellAddress].s = { font: { bold: true } };
        }

        // 🔹 Number Formatting: ONLY apply to Data Rows and Totals (Ignoring Top Filters)
        if (R > tableHeaderRowIndex && worksheet[cellAddress].t === "n") {
          if (C === 0) {
            // S.No column must be strict integer
            worksheet[cellAddress].z = "0";
          } else {
            // All other numbers in data rows get 2 decimal places
            worksheet[cellAddress].z = "#,##0.00";
          }
        }
      }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <button
      onClick={generateExcel}
      className="px-4 py-2 bg-green-600 text-white rounded text-sm hover:bg-green-700"
    >
      Export to Excel
    </button>
  );
};

export default ExcelExport;